import React from "react";
import { ReactComponent as StanfordLogo } from "../../assets/logos/partner-stanford.svg";
import { ReactComponent as MayoLogo } from "../../assets/logos/partner-mayo.svg";

const Partners = () => {
  return (
    <div className="px-5 lg:px-10 py-10 border-t border-zinc-250">
      <div className="w-full lg:max-w-7xl mx-auto flex flex-col items-center">
        <p className="text-lg lg:text-2xl mb-2 text-center">
          Working with leading organizations
        </p>
        <div className="flex flex-col lg:flex-row items-center mb-4">
          <StanfordLogo />
          <MayoLogo />
        </div>
      </div>
    </div>
  );
};

export default Partners;
